import { render, staticRenderFns } from "./helpInfo.vue?vue&type=template&id=2b60c9d6&scoped=true"
import script from "./helpInfo.vue?vue&type=script&lang=js"
export * from "./helpInfo.vue?vue&type=script&lang=js"
import style0 from "./helpInfo.vue?vue&type=style&index=0&id=2b60c9d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60c9d6",
  null
  
)

export default component.exports